// Menu Vendas → Pré-contratos (2026-10-05). Chave "sales" fica fora da
// persistência do React Query (dado pessoal) — ver __root.tsx.
import { useQuery } from "@tanstack/react-query";
import { salesService } from "@/services/gpsdrive-sales.service";

export const SALES_LEADS_KEY = ["sales", "leads"] as const;

export const useSalesAccess = (enabled = true) =>
  useQuery({
    queryKey: ["sales", "access"],
    queryFn: salesService.access,
    enabled,
    staleTime: 60_000,
    retry: 1,
  });

export const useSalesLeads = (enabled = true) =>
  useQuery({
    queryKey: SALES_LEADS_KEY,
    queryFn: salesService.list,
    enabled,
  });

export const SALES_SHEET_KEY = ["sales", "sheet"] as const;

export const useSalesSheet = (enabled = true) =>
  useQuery({
    queryKey: SALES_SHEET_KEY,
    queryFn: salesService.sheet,
    enabled,
    retry: 1,
  });
